<template>
  <!-- 用户管理-用户福利查询 -->
  <div class="benefit-statistical-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item label="领取时间段:">
          <el-date-picker
            v-model="query.start_time"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box" v-if="dataList">
      <h3>
        各种口令红包领取金额:<span style="color: green">
          {{ Number(dataList.red_envelope).toFixed(2) }}钻石</span
        >
      </h3>
      <br />
      <h3>
        官方ROLL房中的东西价值:<span style="color: green">
          {{ Number(dataList.roll).toFixed(2) }}钻石</span
        >
      </h3>
      <br />
      <h3>
        定时ROLL房中的东西价值:<span style="color: green">
          {{ Number(dataList.activity_roll).toFixed(2) }}钻石</span
        >
      </h3>
      <br />
      <h3>
        活动获取的商城币(后台修改):<span style="color: green">
          {{ Number(dataList.shop_balance).toFixed(2) }}G币</span
        >
      </h3>
      <br />
      <h3>
        活动获取的钻石(后台修改):<span style="color: green">
          {{ Number(dataList.account_balance).toFixed(2) }}钻石</span
        >
      </h3>
      <br />
    </div>
  </div>
</template>
<script>
import { server, delData, patchData, getData, postApiData } from '../../http'
export default {
  data() {
    return {
      query: {
        user_id: undefined,
        start_time: undefined,
        end_time: undefined
      },
      dataList: undefined,
    }
  },
  created() {

  },
  methods: {
    getData() {
      //获取数据
      let params = this.query
      postApiData(`user_welfare`, params)
        .then(res => {
          this.dataList = res
        })
    }
  }
}
</script>
<style lang="less" scoped>
</style>